import api from "./api";

const createMessage = (data) => {
  return api.post("/api/ticket/message", data);
};

const uploadAttachments = (files, messageId, onUploadProgress) => {
  const formData = new FormData();
  formData.append("messageId", messageId);

  files.forEach((file, index) => {
    const name =
      file?.fileName ||
      file?.name ||
      `attachment-${Date.now().toString()}-${index}`;

    if (file?.uri) {
      formData.append("files", {
        uri: file.uri,
        type: file.type || "application/octet-stream",
        name,
      });
      return;
    }

    formData.append("files", file, name);
  });

  return api.post("/api/ticket/message/attach", formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

const TicketMessageService = {
  createMessage,
  uploadAttachments,
};

export default TicketMessageService;
